var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStateDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.375C9.91792 14.3751 9.83662 14.359 9.76077 14.3276C9.68493 14.2962 9.61604 14.2501 9.55806 14.192L3.30806 7.94197C3.19085 7.82476 3.125 7.66578 3.125 7.50002C3.125 7.33425 3.19085 7.17528 3.30806 7.05806C3.42528 6.94085 3.58425 6.875 3.75002 6.875C3.91578 6.875 4.07476 6.94085 4.19197 7.05806L10 12.8661L15.8081 7.05806C15.9253 6.94085 16.0843 6.875 16.25 6.875C16.4158 6.875 16.5748 6.94085 16.692 7.05806C16.8092 7.17528 16.875 7.33425 16.875 7.50002C16.875 7.66578 16.8092 7.82476 16.692 7.94197L10.442 14.192C10.384 14.2501 10.3151 14.2962 10.2393 14.3276C10.1634 14.359 10.0821 14.3751 10 14.375V14.375Z",
    fill: "#524F4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateDropdown);
export default __webpack_public_path__ + "static/media/state-dropdown.798befbea6710f511a2ad80ad33a787d.svg";
export { ForwardRef as ReactComponent };